/* This file is auto-generated. Please do not edit this manually. */
import gql from "graphql-tag";
export const PosCart = gql`
    fragment PosCart on PosCart {
  orderNumber
  guestToken
  total {
    inCents
    currency
  }
  items {
    ... on PosCartItem {
      id
      serialNumber
      name
      eans
      upcs
      variant {
        sku
        imageUrl
        colorTitle
        colorCodes
      }
      product {
        name
        rentalPlans {
          ... on PosItemRentalPlan {
            id
            length {
              value
            }
            price {
              inCents
              currency
            }
          }
        }
        slug
        logistics {
          identifier
        }
      }
      rentalPlan {
        id
        length {
          value
        }
        price {
          inCents
          currency
        }
      }
    }
  }
}
    `;
export const CartAddItemsDocument = gql`
    mutation CartAddItems($input: PosCartAddItemsInput!) {
  posCartAddItems(input: $input) {
    ...PosCart
  }
}
    ${PosCart}`;
export const CartChangeRentalPlanDocument = gql`
    mutation CartChangeRentalPlan($input: PosCartChangeRentalPlanInput!) {
  posCartChangeRentalPlan(input: $input) {
    ...PosCart
  }
}
    ${PosCart}`;
export const PosCartConfirmDocument = gql`
    mutation PosCartConfirm($input: PosCartConfirmInput!) {
  posCartConfirm(input: $input) {
    orderNumber
  }
}
    `;
export const GetOrCreateCartForClerkDocument = gql`
    mutation getOrCreateCartForClerk {
  posCartGetOrCreate {
    ...PosCart
  }
}
    ${PosCart}`;
export const CartLockDocument = gql`
    mutation CartLock($input: PosCartLockInput!) {
  posCartLock(input: $input) {
    orderNumber
  }
}
    `;
export const CartReCreateDocument = gql`
    mutation CartReCreate($input: PosCartInput!) {
  posCartRecreate(input: $input) {
    orderNumber
  }
}
    `;
export const CartRemoveItemDocument = gql`
    mutation CartRemoveItem($input: PosCartRemoveItemInput!) {
  posCartRemoveItem(input: $input) {
    ...PosCart
  }
}
    ${PosCart}`;
export const CartShareDocument = gql`
    mutation CartShare($input: PosCartSharedInput!) {
  posCartShare(input: $input) {
    shareLink
  }
}
    `;
export const GetClerkOrderListDocument = gql`
    query GetClerkOrderList {
  clerkOrderList {
    orderNumber
    state {
      status
      progress
    }
    items {
      variant {
        imageUrl
      }
    }
    user {
      id
      firstName
      lastName
    }
  }
}
    `;
export const GetDocumentsDocument = gql`
    query GetDocuments($input: PosDocumentsInput!) {
  posDocuments(input: $input) {
    key
    type
    orderNumber
  }
}
    `;
export const GetCartDocument = gql`
    query GetCart($orderNumber: String!) {
  posCart(input: {orderNumber: $orderNumber}) {
    ...PosCart
    state {
      progress
      status
    }
    storeCode
    createdAt
    user {
      id
      firstName
      lastName
      email
      birthdate
    }
  }
}
    ${PosCart}`;
